import "core-js/modules/es.object.from-entries.js";

/**
 * More strictly typed version of `Object.fromEntries`.
 * Constructs an object from key-value pairs.
 */
export function fromEntries(entries) {
  return Object.fromEntries(entries);
}